import Logo from "@/components/Logo";
import Hero from "@/optiona/Hero";
import { Marquee, Specialties, Method } from "@/optiona/Sections";
import Programs from "@/optiona/Programs";
import { About, Faq, Contact } from "@/optiona/Closing";
import { EMAIL } from "@/lib/content";

const FOOTER_LINKS = [
  { href: "#specialties", label: "What I help with", tid: "footer-link-specialties" },
  { href: "#programs", label: "Programs", tid: "footer-link-programs" },
  { href: "#about", label: "About", tid: "footer-link-about" },
  { href: "#faq", label: "FAQ", tid: "footer-link-faq" },
  { href: "#contact", label: "Contact", tid: "footer-link-contact" },
];

function Footer() {
  return (
    <footer className="bg-royaldeep overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <p
          aria-hidden="true"
          className="font-displayb italic font-light text-[clamp(3.2rem,10vw,9rem)] leading-none text-[#6C97DD]/70 select-none"
        >
          Well&Truly
        </p>
        <p aria-hidden="true" className="mt-3 text-xs uppercase tracking-[0.34em] text-butter/90">
          by Akanksha
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <Logo variant="a" accent="text-butter" />
          <nav className="flex flex-wrap gap-x-7 gap-y-3 text-sm text-white/70">
            {FOOTER_LINKS.map((l) => (
              <a key={l.href} href={l.href} data-testid={l.tid} className="hover:text-butter transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
          <div className="sm:text-right text-sm">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              className="text-cream hover:text-butter transition-colors"
            >
              {EMAIL}
            </a>
            <p className="mt-1 text-white/60">Dubai, United Arab Emirates</p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Well&Truly by Akanksha. All rights reserved.
          </span>
          <span>wellandtruly.fit</span>
        </div>
      </div>
    </footer>
  );
}

export default function OptionA() {
  return (
    <div className="grain bg-[#F7F9FC] font-bodya text-navy" data-testid="page-option-a">
      <Hero />
      <Marquee />
      <Specialties />
      <Method />
      <Programs />
      <About />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}
